import axios from "axios";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import { clearCart } from "../redux/cart";
// import { clearCategories } from "../redux/category";
import { logoutRestaurant } from "../redux/restaurant";

export const AuthContext = React.createContext({});

const AuthContextProvider = ({ children }) => {
  // const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loggedInUser, setLoggedInUser] = useState(null);
  const [token, setToken] = useState(null);
  const [logginChecked, setLogginChecked] = useState(false);
  // console.log("Ouside: ", window.location.pathname);

  const logout = () => {
    setLoggedInUser(null);
    setToken(null);

    dispatch(logoutRestaurant());
  };

  const login = (user, userToken) => {
    axios
      .get("/restaurant", { headers: { Authorization: `Bearer ${userToken}` } })
      .then((res) => {
        let restaurantDetails = {
          ...user,
          restaurant_id: res.data.restaurant.id,
        };

        localStorage.setItem("user", JSON.stringify(restaurantDetails));
        localStorage.setItem("token", userToken);

        setLoggedInUser(restaurantDetails);
        setToken(userToken);
      });
  };

  useEffect(() => {
    const user = localStorage.getItem("user");
    const token = localStorage.getItem("token");
    if (user && token) {
      setLoggedInUser(JSON.parse(user));
      setToken(token);
    }
    setLogginChecked(true);
  }, []);

  return (
    <AuthContext.Provider
      value={{ loggedInUser, token, login, logout, logginChecked }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContextProvider;
